export const getMapBoundsForAllCars = (
  map,
  maps,
  allCarData,
  isValidLocation,
  setAll
) => {
  const bounds = new maps.LatLngBounds();
  allCarData.map((item) => {
    if (isValidLocation(item.Car.Latitude, item.Car.Longitude)) {
      bounds.extend(new maps.LatLng(item.Car?.Latitude, item.Car?.Longitude));
    }
  });
  setAll(false);
  return bounds;
};
